import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../Components/DataGrid/WSMobileDataGridAdvanced";
import { callAPI, IsSmallScreen, MasterPages, Method, updateMainHeader } from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { AllPermissions, getPermissions } from "../../commonFunctions/PermissionManger";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import ConfirmDialog, { useConfirmDialog } from "../../Components/Confirmation/ConfirmDialog";
import { useDispatch } from "react-redux";
import { resetDataComponent } from "../../StateManagement/actions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";

export const CallLogList: React.FC<any> = React.memo((props) => {
    AllPermissions.getInstance();
    const { showMessage } = useSnackbar();
    const dispatch = useDispatch()
    const { add, edit, remove, view } = AllPermissions.getCallPermission;
    const {
        open,
        title,
        onConfirm,
        handleClose,
        openConfirmDialog,
    } = useConfirmDialog();
    const navigate = useNavigate();
    const isMobile = IsSmallScreen();
    useEffect(() => {
        updateMainHeader("Calls");

        breadCrumbsStore.updateBreadCrumbs([
            { "Calls": "" },


        ]);
    });
    const source = {
        url: "call-logs/search",
        page: 1,
        pageSize: 10,
        filter: [
        ],
        sort: [],
    };

    /**
     * Edit function
     * @param action 
     * @param row 
     */
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`/call/edit/${row?.id}`)
        } else if (action === "Delete") {
            openConfirmDialog("Delete this record?", () => handleDelete(row?.id))
        }

    };

    const handleDelete = async (id?: string | number) => {
        const response: any = await callAPI(`call-logs`, Method.DELETE, null, id);
        dispatch(resetDataComponent('callLogMainListGrid'));
        if (response?.success) {
            showMessage(response?.message, "success")
        }
        else {
            showMessage(response?.message || 'Something went wrong', "error")
        }
        handleClose()

    };
    const columns: IColumns[] = [
        {
            header: "Subject",
            fieldName: "subject",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Type",
            fieldName: "callType",
            tooltip: true,

            type: 'default'
        },
        {
            header: "Start",
            fieldName: "callStart",
            tooltip: true,
            type: 'dateTime'
        },
        {
            header: "callStatus",
            fieldName: "callStatus",
            tooltip: true,
            type: 'status'
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined, remove ? "Delete" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];
    const mobColumns: IOrderColumns[] = [
        {
            header: "Subject",
            fieldName: "subject",
            tooltip: true,
            type: 'default',
            labelSx: { fontWeight: 'bold' }
        },
        {
            header: "Type",
            fieldName: "callType",
            tooltip: true,

            type: 'default'
        },
        {
            header: "callStatus",
            fieldName: "callStatus",
            tooltip: true,

        },
        {
            header: "Start",
            fieldName: "callStart",
            tooltip: true,
            type: 'date',
            labelSx: { marginLeft: 2 },
            sm: 8,
            isBoderRadious: true
        },

        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];
    const handleClick = () => {
        navigate('/call/create')
    }
    return (
        <>
            <Grid container spacing={2}>
                {view ? <Grid item xs={12}>
                    {!isMobile && <WSDataGrid
                        id="callLogMainListGrid"
                        title="Calls"
                        columns={columns}
                        source={source}
                        addButton={{ label: 'New', color: 'secondary', }}
                        onAddButtonClick={handleClick}
                        gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
                    />
                    }
                    {isMobile &&
                        <WSMobileDataGridAdvanced title={'Calls'} addButton={add ? { label: "New", color: "secondary" } : undefined}
                            onAddButtonClick={handleClick} columns={mobColumns} id="callLogMainListGrid" source={source} />
                    }
                </Grid>
                    : <PermissionDenied />}
                <ConfirmDialog
                    open={open}
                    title={title}
                    onConfirm={onConfirm}
                    onClose={handleClose}
                />
            </Grid>
        </>
    )
})